import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent } from 'react';
import { TimeTrackingConfiguration } from '../../../classes/entities/TimeTrackingConfiguration/timeTrackingConfigurationTypes';
import { TimeTrackingConfigurationListItem } from '../TimeTrackingConfigurationListItem/TimeTrackingConfigurationListItem';

export type TimeTrackingConfigurationListProps = ComponentProps<'div'> & {
  readonly timeTrackingConfigurations: Array<TimeTrackingConfiguration>;
};

export const TimeTrackingConfigurationList: FunctionComponent<
  TimeTrackingConfigurationListProps
> = (props) => {
  const { timeTrackingConfigurations, ...remainingProps } = props;

  return (
    <div {...remainingProps}>
      {timeTrackingConfigurations.map((config) => {
        return (
          <TimeTrackingConfigurationListItem
            timeTrackingConfiguration={config}
            key={EntityUtils.getTrackingKey(config)}
          ></TimeTrackingConfigurationListItem>
        );
      })}
    </div>
  );
};
